import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        onlineUsers: []
    },

    mutations: {
        'onlineUsersModel/setOnlineUsers': function (state, onlineUsers) {
            let userList = {};

            onlineUsers.sort((a, b) => {
                if (a.alias.toLowerCase() < b.alias.toLowerCase()) return -1;
                if (a.alias.toLowerCase() > b.alias.toLowerCase()) return 1;
                return 0;
            });
            onlineUsers.forEach((onlineUser) => {
                userList[onlineUser.stringUrl] = onlineUser;
            });

            state.onlineUsers = userList;
        }
    }
}


// WEBPACK FOOTER //
// ./src/ChatRoom/OnlineUsersModel.js